import { PlansService } from 'src/app/data/repository/plans-repository/plans.service';
import { ExerciseLogService } from './../../data/repository/plan-repository/exercise-log.service';
import { ExerciseService } from './../../data/repository/plan-repository/exercise.service';
import { TutorialService } from 'src/app/data/repository/tutorial-repository/tutorial.service';
import { GenerateShared } from 'src/app/presentation/general/shared/generate-shared';
import { ReferralDialogComponent } from './referral-dialog/referral-dialog.component';
import { MealRatio } from './../../core/model/object/diet-model';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { DateHelper } from 'src/app/utils/date-helper';
import { CalendarShared } from '../general/shared/calendar-shared';
import { Subscription } from 'rxjs';
import {
  DietDayModel,
  DietMealModel,
} from 'src/app/core/model/object/diet-model';
import { PlanStatusInputModel } from 'src/app/core/model/input/plan-status-input-model';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { PlanShared } from '../general/shared/plan-shared';
import { BottomsheetShared } from '../general/shared/bottomsheet-shared';
import { ShopService } from 'src/app/data/repository/shop-repository/shop.service';
import { TutorialShared } from '../general/shared/tutorial-shared';
import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';
import { LogoutService } from 'src/app/data/repository/user-repository/logout.service';
import { WeightLogService } from 'src/app/data/repository/plan-repository/weight-log.service';
import { MatDialog } from '@angular/material/dialog';
import { GenericResponse } from 'src/app/data/repository/generic-response';
import { DietApiService } from 'src/app/data/repository/plan-repository/diet-api.service';

@Component({
  selector: 'app-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.scss'],
})
export class PlanComponent implements OnInit, OnDestroy {
  selectedDayTitle = '';
  dietDay: DietDayModel;
  cheatDayCount = 2;
  dietId: string;
  showWeight = true;
  dateStatus: number;
  isBeforeStart: boolean;
  hasDiet: boolean;
  isCheatDay: boolean;
  lockPlan = false;
  dietCalorie: number;
  chartStatus = '';
  planStatusInput: PlanStatusInputModel;
  mealRatios: MealRatio[] = [];
  isPredefined = false;
  // data is ready
  planDataIsReady = false;
  weightDataIsReady = true;
  exerciseIsReady = false;

  plansDieId: string;
  exerciseCalories: number = 0;

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;
  subscription5: Subscription;
  subscription6: Subscription;

  constructor(
    private planService: PlanService,
    public calendarShared: CalendarShared,
    private dateHelper: DateHelper,
    private snackBarService: SnackBarService,
    private planShared: PlanShared,
    private bottomsheetShared: BottomsheetShared,
    private shopService: ShopService,
    private tutorialShared: TutorialShared,
    private diaryAnalytics: DiaryAnalyticsService,
    private weightLogService: WeightLogService,
    private dialog: MatDialog,
    private generateShared: GenerateShared,
    private tutorialService: TutorialService,
    private exerciseService: ExerciseService,
    private exerciseLogService: ExerciseLogService,
    private logoutService: LogoutService,
    private dietApiService: DietApiService
  ) {
    if (!this.calendarShared.selectedDate) {
      this.calendarShared.selectedDate = new Date(
        new Date().setHours(0, 0, 1, 0)
      );
    }
    if (
      localStorage.getItem('referral-success') &&
      localStorage.getItem('referral-success') === '1'
    ) {
      const dialogRef = this.dialog.open(ReferralDialogComponent, {
        width: '90%',
        panelClass: 'custom-dialog-container',
      });
      localStorage.setItem('referral-success', '0');
    }

    this.subscription1 = this.calendarShared.closeCalendarObs$.subscribe(
      (close) => {
        if (close) {
          this.initialing(true);
        }
      }
    );
    this.subscription2 = this.planShared.removeCheatDayObs$.subscribe(
      (remove) => {
        if (remove) {
          this.planService
            .cheatDay(this.dietId, parseInt(this.dietDay.day), false)
            .then((res) => {
              if (res.isSuccess()) {
                this.initialing(true);
              } else {
                this.snackBarService.showSnackBar(
                  'خطا در برقراری ارتباط با سرور!'
                );
              }
            });
        }
      }
    );
    this.subscription3 =
      this.bottomsheetShared.closeAndUpdateBottomsheetObs$.subscribe(
        (close) => {
          if (close) {
            this.initialing(true);
          }
        }
      );
    this.subscription4 = this.planShared.refreshDietDayObs$.subscribe(
      (refresh) => {
        if (refresh) {
          this.initialing(false);
        }
      }
    );
    this.subscription5 = this.planShared.refreshDietObs$.subscribe(
      (refresh) => {
        if (refresh) {
          this.initialing(false);
        }
      }
    );
    this.subscription6 = this.planShared.saveRatios.subscribe((i) => {
      this.planShared.selectedMealRatio = this.mealRatios[i];
    });
  }

  async ngOnInit() {
    this.diaryAnalytics.analyticDiaryVisited();

    await this.initialing(true);
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
    this.subscription5.unsubscribe();
  }

  refresh() {
    window.location.reload();
  }

  checkTutorial() {
    this.tutorialShared.calendarBox = document.getElementById('calendar-box');
    this.tutorialShared.cheatDayBox = document.getElementById('cheat-day-box');
    if (this.hasDiet && !this.isBeforeStart) {
      this.tutorialService.checkDietTutorial();
    }
  }

  nextDay() {
    this.diaryAnalytics.analyticDiaryDateNavigated();
    this.calendarShared.selectedDate = new Date(
      this.calendarShared.selectedDate.setDate(
        this.calendarShared.selectedDate.getDate() + 1
      )
    );
    this.calendarShared.selectedDate = new Date(
      this.calendarShared.selectedDate.setHours(0, 0, 1, 0)
    );
    this.initialing(true);
  }

  previousDay() {
    this.diaryAnalytics.analyticDiaryDateNavigated();
    this.calendarShared.selectedDate = new Date(
      this.calendarShared.selectedDate.setDate(
        this.calendarShared.selectedDate.getDate() - 1
      )
    );
    this.calendarShared.selectedDate = new Date(
      this.calendarShared.selectedDate.setHours(0, 0, 1, 0)
    );
    this.initialing(true);
  }

  prepare() {
    this.planDataIsReady = false;
    this.showWeight = this.dateStatus !== 1 ? true : false;
    this.selectedDayTitle =
      this.dateHelper.getTodayYesterdayTomorrowOrMonthAndDay(
        this.calendarShared.selectedDate
      );
    this.planShared.refreshMyPlan();
    setTimeout(() => {
      this.planDataIsReady = true;
      this.weightDataIsReady = true;
    }, 10);
    setTimeout(() => {
      this.checkTutorial();
    }, 20);
  }

  goToCheatDay() {
    if (this.cheatDayCount <= 2) {
      this.planService.goToCheatDay(
        this.dietId,
        this.dietDay.day,
        this.dietDay.isCheatDay,
        this.cheatDayCount,
        this.isPredefined
      );
    }
  }

  goToShop() {
    this.shopService.goToShopPage('lockView');
  }

  openCalendar() {
    this.calendarShared.openCalendar();
  }
  async updateExercise() {
    const logs = await this.exerciseService.getTodayExercise(
      this.calendarShared.selectedDate.getTime()
    );
    await this.exerciseLogService.updateExerciseLogs(
      logs.getData().getResponseDayLogs(),
      this.calendarShared.selectedDate.getTime()
    );

    const data = await this.exerciseLogService.getDayExercises(
      this.calendarShared.selectedDate.getTime()
    );

    this.exerciseCalories = 0;
    this.exerciseIsReady = false;

    if (data !== null) {
      await data.exerciseLogs.map((current) => {
        if (current.calorie) {
          this.exerciseCalories += current.calorie;
        }
      });
    }
    this.exerciseIsReady = true;
    this.exerciseLogService.CDate = this.calendarShared.selectedDate.getTime();
  }
  async getExerciseClories() {
    await this.exerciseService.getTodayExercise(
      this.calendarShared.selectedDate.getTime()
    );

    const data = await this.exerciseLogService.getDayExercises(
      this.calendarShared.selectedDate.getTime()
    );

    this.exerciseCalories = 0;
    this.exerciseIsReady = false;

    if (data !== null) {
      data.exerciseLogs.map((current) => {
        if (current.calorie) {
          this.exerciseCalories += current.calorie;
        }
      });
    }
    this.exerciseLogService.CDate = this.calendarShared.selectedDate.getTime();
  }

  async checkTodayPlan() {
    let today;
    if (
      this.calendarShared.selectedDate ==
      new Date(new Date().setHours(0, 0, 1, 0))
    ) {
      today = new Date(new Date().setHours(0, 0, 1, 0));
    } else {
      today = this.calendarShared.selectedDate;
    }
    const todayResponse = await this.planService.checkThisDayPlan(
      this.calendarShared.selectedDate,
      false,
      false
    );

    if (todayResponse.isSuccess()) {
      if (todayResponse.getData().getType() === 'before') {
        this.planShared.dietType = (
          todayResponse.getData() as any
        ).params.dietType.name;
        this.planStatusInput = new PlanStatusInputModel(
          'before',
          'assets/general/bento.png',
          (todayResponse.getData() as any).params.dietType.name,
          todayResponse.getData().getDaysCount().toString() + ' روز تا شروع',
          true,
          false
        );
      } else if (todayResponse.getData().getType() === 'diet') {
        let isFasting = false;
        let duration = 0;
        let endTime = 0;

        if (todayResponse.getData().getDietType().type === 'daily') {
          let dayOfWeek = today.getDay() + 2;
          dayOfWeek = dayOfWeek === 8 ? 1 : dayOfWeek;
          if (
            todayResponse.getData().getFasting().fastingDays.includes(dayOfWeek)
          ) {
            isFasting = true;
          } else {
            isFasting = false;
          }
        } else if (todayResponse.getData().getDietType().type === 'hourly') {
          const now = new Date();
          const fastingTime = new Date(
            new Date().setHours(
              new Date(
                todayResponse.getData().getFasting().fastingTime
              ).getHours(),
              new Date(
                todayResponse.getData().getFasting().fastingTime
              ).getMinutes(),
              new Date(
                todayResponse.getData().getFasting().fastingTime
              ).getSeconds()
            )
          );

          if (fastingTime.getTime() > now.getTime()) {
            if (
              fastingTime.getTime() - now.getTime() >
              (24 - todayResponse.getData().getFasting().fasting) *
                (60 * 60 * 1000)
            ) {
              isFasting = true;
              endTime =
                todayResponse.getData().getFasting().fastingTime +
                todayResponse.getData().getFasting().fasting * 60 * 60 * 1000;
            } else {
              isFasting = false;
              endTime = todayResponse.getData().getFasting().fastingTime;
            }
          } else {
            if (
              now.getTime() - fastingTime.getTime() >
              todayResponse.getData().getFasting().fasting * (60 * 60 * 1000)
            ) {
              isFasting = false;
              endTime = todayResponse.getData().getFasting().fastingTime;
            } else {
              isFasting = true;
              endTime =
                todayResponse.getData().getFasting().fastingTime +
                todayResponse.getData().getFasting().fasting * 60 * 60 * 1000;
            }
          }
          duration = isFasting
            ? todayResponse.getData().getFasting().fasting
            : 24 - todayResponse.getData().getFasting().fasting;
        }
        this.planStatusInput = new PlanStatusInputModel(
          todayResponse.getData().getDietType().type === 'daily'
            ? 'daily'
            : todayResponse.getData().getDietType().type === 'hourly'
            ? 'hourly'
            : 'diet',
          'assets/general/bento.png',
          this.planShared.dietType.name,
          todayResponse.getData().getDietRemainingDays() +
            ' روز تا پایان' +
            (todayResponse.getData().getDietType().type === 'daily'
              ? isFasting
                ? ' - روز فستینگ'
                : ' - روز عادی'
              : todayResponse.getData().getDietType().type === 'hourly'
              ? isFasting
                ? ' - بازه فستینگ'
                : ' - بازه مجاز'
              : ''),
          true,
          isFasting,
          null,
          null,
          duration !== 0 ? duration : null,
          endTime !== 0 ? endTime : null
        );
      } else if (todayResponse.getData().getType() === 'cheatDay') {
        this.planStatusInput = new PlanStatusInputModel(
          'cheatDay',
          'assets/plan/cheatdayEmoji.svg',
          this.planShared.dietType.name,
          'روز آزاد 😋',
          true,
          false
        );
      } else if (todayResponse.getData().getType() === 'generate') {
        if (this.planShared.isDeeplink) {
          this.planService.goToGenerate();
        }
        this.planStatusInput = new PlanStatusInputModel(
          'generate',
          'assets/profile/diet.png',
          'شما برنامه غذایی ندارید!',
          'همین حالا برنامه غذایی تهیه کنید',
          true,
          false
        );
      }

      this.prepare();
    } else {
      if (this.planShared.isDeeplink) {
        this.planService.goToGenerate();
      }
      this.planStatusInput = new PlanStatusInputModel(
        'generate',
        'assets/profile/diet.png',
        'شما برنامه غذایی ندارید!',
        'همین حالا برنامه غذایی تهیه کنید',
        true,
        false
      );
      this.prepare();
    }
  }
  async initialing(updateFoodLogs: boolean) {
    await this.weightLogService.getWeight();
    this.weightDataIsReady = true;
    await this.getExerciseClories();
    this.exerciseIsReady = true;

    await this.planService.getDietList();

    const planData = await this.planService.checkThisDayPlan(
      this.calendarShared.selectedDate,
      true,
      updateFoodLogs
    );

    const stableCalorie = await this.planService.getUserStableCalorie(
      this.calendarShared.selectedDate
    );

    if (planData.isSuccess()) {
      const type = planData.getData().getType();
      await this.prepearplans(planData, type, stableCalorie);
    } else {
      if (
        planData.getData() &&
        planData.getData().getType() &&
        planData.getData().getType() === 'refresh'
      ) {
        const d = await this.dietApiService.getDiets();
        const r = await this.planService.getDietListAndRefreshDB();
        if (r.isSuccess()) {
          await this.planService.getDietList();

          // const planData = await this.planService.checkThisDayPlan(
          //   this.calendarShared.selectedDate,
          //   true,
          //   updateFoodLogs
          // );

          const stableCalorie = await this.planService.getUserStableCalorie(
            this.calendarShared.selectedDate
          );

          const type = planData.getData().getType();

          await this.prepearplans(planData, type, stableCalorie);
          this.planDataIsReady = true;
        } else {
          this.logoutService.logout();
          this.snackBarService.showSnackBar(
            ' توکن منقضی شده است . دوباره وارد شوید '
          );
          this.planDataIsReady = true;
        }
      } else {
        this.dietId = '1';
        this.cheatDayCount = -1;
        this.isPredefined = false;
        this.lockPlan = false;
        this.planShared.lockPlan = this.lockPlan;
        this.chartStatus = 'stable';
        this.dietCalorie = stableCalorie;
        const meals = [
          new DietMealModel('generate', '', 'breakfast', []),
          new DietMealModel('generate', '', 'snack1', []),
          new DietMealModel('generate', '', 'lunch', []),
          new DietMealModel('generate', '', 'snack2', []),
          new DietMealModel('generate', '', 'dinner', []),
          new DietMealModel('generate', '', 'snack3', []),
        ];
        this.dietDay = new DietDayModel(false, '0', '0', meals);
        this.dietDay.meals.forEach((meal) => {
          this.mealRatios.push(
            new MealRatio(
              '',
              meal.meal,
              this.planService.getMealRatio(meal.meal),
              this.planService.getMealPersianName(meal.meal)
            )
          );
        });
        this.hasDiet = false;
        this.isBeforeStart = false;
        await this.checkTodayPlan();
        this.planDataIsReady = true;
        // this.prepare();
      }
    }

    await this.updateExercise();
  }

  checkDateStatus(date: Date): number {
    const current = new Date(new Date().setHours(0, 0, 1, 0));
    if (date > current) {
      return 1;
    } else if (date < current) {
      return -1;
    } else {
      return 0;
    }
  }

  private calculateDays(endDate: number, startDate: number): number {
    const diffTime = endDate - startDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }
  async prepearplans(
    planData: GenericResponse,
    type: string,
    stableCalorie: number
  ) {
    if (type === 'before') {
      const subscription = await this.shopService.getPlanSubscription(false);
      if (subscription.isSuccess()) {
        const expireDate = subscription
          .getData()
          .getPlanSubscription().expireDate;
        this.lockPlan =
          this.calculateDays(
            expireDate,
            this.calendarShared.selectedDate.getTime()
          ) < 0
            ? true
            : false;
        this.planShared.lockPlan = this.lockPlan;
      }
      this.bottomsheetShared.startDay = subscription.getData().getDaysCount();
      this.bottomsheetShared.selectedDietId = subscription
        .getData()
        .getDietId();

      this.cheatDayCount = -1;
      this.chartStatus = 'stable';
      this.dietCalorie = stableCalorie;
      this.dietId = subscription.getData().getDietId();
      this.isPredefined = false;
      this.planShared.dietType = subscription.getData().getDietType();
      const meals = [
        new DietMealModel('before', '', 'breakfast', []),
        new DietMealModel('before', '', 'snack1', []),
        new DietMealModel('before', '', 'lunch', []),
        new DietMealModel('before', '', 'snack2', []),
        new DietMealModel('before', '', 'dinner', []),
        new DietMealModel('before', '', 'snack3', []),
      ];
      this.dietDay = new DietDayModel(false, '0', '0', meals);
      this.dietDay.meals.forEach((meal) => {
        this.mealRatios.push(
          new MealRatio(
            '',
            meal.meal,
            this.planService.getMealRatio(meal.meal),
            this.planService.getMealPersianName(meal.meal)
          )
        );
      });
      this.planShared.selectedDietDay = this.dietDay;
      this.hasDiet = true;
      this.isBeforeStart = true;
      this.isCheatDay = false;
      await this.checkTodayPlan();
      this.planDataIsReady = true;
    } else if (type === 'diet') {
      this.shopService.getPlanSubscription(false).then(async (result) => {
        if (result.isSuccess()) {
          const expireDate = result.getData().getPlanSubscription().expireDate;
          this.lockPlan =
            this.calculateDays(
              expireDate,
              this.calendarShared.selectedDate.getTime()
            ) < 0
              ? true
              : false;
          this.planShared.lockPlan = this.lockPlan;
        }
        this.chartStatus = 'diet';
        this.dietCalorie = planData.getData().getDietCalorie();
        this.dietId = planData.getData().getDietId();
        this.cheatDayCount = planData.getData().getDaysCount();

        this.dietDay = planData.getData().getDietDay();
        this.planShared.dietType = planData.getData().getDietType();
        this.isPredefined =
          !planData.getData().getDietType().isPersonal &&
          !planData.getData().getDietType().fasting;

        let date = new Date(planData.getData().getMessage());
        date = new Date(date.setDate(date.getDate() - 1));
        const dateTitle = this.dateHelper.getMonthAndDayPersian(date);
        if (planData.getData().getDietType().mealRatioArray.length === 1) {
          this.mealRatios = planData
            .getData()
            .getDietType().mealRatioArray[0].mealRatios;
        } else {
          let dayOfWeek = this.calendarShared.selectedDate.getDay() + 2;
          dayOfWeek = dayOfWeek === 8 ? 1 : dayOfWeek;
          if (planData.getData().getFasting().fastingDays.includes(dayOfWeek)) {
            planData
              .getData()
              .getDietType()
              .mealRatioArray.forEach((mr) => {
                if (mr.type !== 'normal') {
                  this.mealRatios = mr.mealRatios;
                }
              });
            this.dietCalorie = planData.getData().getFasting().fastingCalorie;
          } else {
            planData
              .getData()
              .getDietType()
              .mealRatioArray.forEach((mr) => {
                if (mr.type === 'normal') {
                  this.mealRatios = mr.mealRatios;
                }
              });
          }
        }
        this.generateShared.cancelDay = parseInt(this.dietDay.day);
        this.planShared.selectedDietDay = this.dietDay;
        this.hasDiet = true;
        this.isBeforeStart = false;
        this.isCheatDay = false;
        await this.checkTodayPlan();
        // this.prepare();
      });
    } else if (type === 'cheatDay') {
      const subscription = await this.shopService.getPlanSubscription(false);
      if (subscription.isSuccess()) {
        const expireDate = subscription
          .getData()
          .getPlanSubscription().expireDate;
        this.lockPlan =
          this.calculateDays(
            expireDate,
            this.calendarShared.selectedDate.getTime()
          ) < 0
            ? true
            : false;
        this.planShared.lockPlan = this.lockPlan;
      }
      this.chartStatus = 'cheatDay';
      this.dietCalorie = stableCalorie;
      this.dietId = planData.getData().getDietId();
      this.cheatDayCount = planData.getData().getDaysCount();
      this.dietDay = planData.getData().getDietDay();
      this.planShared.selectedDietDay = this.dietDay;
      // const tempMealRatios = res.getData().getMealRatios();
      this.planShared.dietType = planData.getData().getDietType();

      this.isPredefined =
        !planData.getData().getDietType().isPersonal &&
        !planData.getData().getDietType().fasting;
      this.hasDiet = true;
      this.isBeforeStart = false;
      this.isCheatDay = true;
      if (planData.getData().getDietType().mealRatioArray.length === 1) {
        this.mealRatios = planData
          .getData()
          .getDietType().mealRatioArray[0].mealRatios;
      } else {
        let dayOfWeek = this.calendarShared.selectedDate.getDay() + 2;
        dayOfWeek = dayOfWeek === 8 ? 1 : dayOfWeek;
        if (planData.getData().getFasting().fastingDays.includes(dayOfWeek)) {
          planData
            .getData()
            .getDietType()
            .mealRatioArray.forEach((mr) => {
              if (mr.type !== 'normal') {
                this.mealRatios = mr.mealRatios;
              }
            });
        } else {
          planData
            .getData()
            .getDietType()
            .mealRatioArray.forEach((mr) => {
              if (mr.type === 'normal') {
                this.mealRatios = mr.mealRatios;
              }
            });
        }
      }
      this.generateShared.cancelDay = parseInt(this.dietDay.day);
      await this.checkTodayPlan();
      this.planDataIsReady = true;
    } else if (type === 'hasDiet') {
      let date = new Date(planData.getData().getMessage());
      date = new Date(date.setDate(date.getDate() - 1));
      const dateTitle = this.dateHelper.getMonthAndDayPersian(date);
      this.dietId = '0';
      this.cheatDayCount = -1;
      this.isCheatDay = false;
      this.isPredefined = false;
      this.lockPlan = false;
      this.planShared.lockPlan = this.lockPlan;
      this.chartStatus = 'stable';
      this.dietCalorie = stableCalorie;
      const meals = [
        new DietMealModel('noDiet', '', 'breakfast', []),
        new DietMealModel('noDiet', '', 'snack1', []),
        new DietMealModel('noDiet', '', 'lunch', []),
        new DietMealModel('noDiet', '', 'snack2', []),
        new DietMealModel('noDiet', '', 'dinner', []),
        new DietMealModel('noDiet', '', 'snack3', []),
      ];
      this.dietDay = new DietDayModel(false, '0', '0', meals);
      this.dietDay.meals.forEach((meal) => {
        this.mealRatios.push(
          new MealRatio(
            '',
            meal.meal,
            this.planService.getMealRatio(meal.meal),
            this.planService.getMealPersianName(meal.meal)
          )
        );
      });
      this.hasDiet = false;
      this.isBeforeStart = false;
      await this.checkTodayPlan();
      this.planDataIsReady = true;

      // this.prepare();
    } else if (type === 'generate') {
      this.dietId = '1';
      this.cheatDayCount = -1;
      this.isPredefined = false;
      this.lockPlan = false;
      this.planShared.lockPlan = this.lockPlan;
      this.chartStatus = 'stable';
      this.dietCalorie = stableCalorie;
      const meals = [
        new DietMealModel('generate', '', 'breakfast', []),
        new DietMealModel('generate', '', 'snack1', []),
        new DietMealModel('generate', '', 'lunch', []),
        new DietMealModel('generate', '', 'snack2', []),
        new DietMealModel('generate', '', 'dinner', []),
        new DietMealModel('generate', '', 'snack3', []),
      ];
      this.dietDay = new DietDayModel(false, '0', '0', meals);
      this.dietDay.meals.forEach((meal) => {
        this.mealRatios.push(
          new MealRatio(
            '',
            meal.meal,
            this.planService.getMealRatio(meal.meal),
            this.planService.getMealPersianName(meal.meal)
          )
        );
      });
      this.hasDiet = false;
      this.isBeforeStart = false;
      await this.checkTodayPlan();
      this.planDataIsReady = true;

      // this.prepare();
    } else if (type === 'noDiet') {
      this.isPredefined = false;
      this.lockPlan = false;
      this.planShared.lockPlan = this.lockPlan;
      this.dietId = '0';
      this.chartStatus = 'stable';
      this.dietCalorie = stableCalorie;
      this.cheatDayCount = -1;
      this.isCheatDay = false;
      const meals = [
        new DietMealModel('noDiet', '', 'breakfast', []),
        new DietMealModel('noDiet', '', 'snack1', []),
        new DietMealModel('noDiet', '', 'lunch', []),
        new DietMealModel('noDiet', '', 'snack2', []),
        new DietMealModel('noDiet', '', 'dinner', []),
        new DietMealModel('noDiet', '', 'snack3', []),
      ];
      this.dietDay = new DietDayModel(false, '0', '0', meals);
      this.dietDay.meals.forEach((meal) => {
        this.mealRatios.push(
          new MealRatio(
            '',
            meal.meal,
            this.planService.getMealRatio(meal.meal),
            this.planService.getMealPersianName(meal.meal)
          )
        );
      });
      this.hasDiet = false;
      this.isBeforeStart = false;
      await this.checkTodayPlan();
      this.planDataIsReady = true;
    }
  }
}
